import React, { FC, ReactElement, useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as ArrowIcon } from '@/assets/icons/dropdown-tick.svg';
import { ReactComponent as CheckIcon } from '@/assets/icons/checkMark.svg';
import styles from './PackageOption.module.scss';

interface PackageOptionComponentProps extends PackageOptionProps {
  toggleLabels: ToggleLabels;
}

export interface PackageOptionProps {
  type: string;
  fromPrice: string;
  options: string[];
  className?: string;
}

interface ToggleLabels {
  less: string;
  more: string;
}

const PackageOption: FC<PackageOptionComponentProps> = ({
  options, type, fromPrice, toggleLabels: { less, more }, className,
}: PackageOptionComponentProps) => {
  const [areAllItemsVisible, setAreAllItemsVisible] = useState(true);
  const hasManyItems = options.length > 5;

  const toggleItemsVisibility = (): void => {
    setAreAllItemsVisible((prevAreAllItemsVisible) => !prevAreAllItemsVisible);
  };

  const renderItem = (item: string): ReactElement => (
    <div key={item} className={styles.item}>
      <CheckIcon className={styles.check} />
      {item}
    </div>
  );

  return (
    <div className={classNames(className)}>
      <div className={styles.name}>{type}</div>
      <div className={styles.price}>{fromPrice}</div>
      <div className={classNames(styles.items, areAllItemsVisible && styles.hidden)}>
        {options.map(renderItem)}
      </div>
      {hasManyItems && (
        <div className={styles.toggleButton} onClick={toggleItemsVisibility}>
          {areAllItemsVisible ? more : less}
          <ArrowIcon
            className={classNames(styles.arrowIcon, !areAllItemsVisible && styles.isOpen)}
          />
        </div>
      )}
    </div>
  );
};

export default PackageOption;
